<template>
  <div class="detail-product-card">
    <div class="flex-column gap-label">
      <span class="text-label">Estimasi Perhitungan Pengembalian Dana</span>
      <div class="gray-divider"></div>

      <div class="flex-column gap-label-value">
        <div class="flex-column gap-label-value">
          <span class="text-label-no-uppercase">Penempatan Dana</span>
          <input
            type="text"
            class="input-style"
            placeholder="Rp0"
            v-model="penempatanDana"
            @input="onPenempatanInput"
          />
        </div>
        <div class="flex-column gap-label-value">
          <span class="text-label-no-uppercase">Jangka Waktu</span>
          <input
            type="text"
            class="input-style disable-input"
            :value="jangkaWaktu"
            readonly
            disabled
          />
        </div>
        <div class="flex-column gap-label-value">
          <span class="text-label-no-uppercase">Estimasi Bagi Hasil</span>
          <input
            type="text"
            class="input-style disable-input"
            placeholder="Rp0"
            v-model="estimasiBagiHasil"
            readonly
            disabled
          />
        </div>
      </div>

      <div class="gray-divider"></div>

      <div class="flex-column gap-label-value">
        <div class="flex-column gap-label-value">
          <span class="text-label-no-uppercase">Estimasi Total Pengembalian</span>
          <input
            type="text"
            class="input-style disable-input"
            placeholder="Rp0"
            v-model="totalPengembalian"
            readonly
            disabled
          />
        </div>
        <div class="flex-column gap-label-value">
          <span class="text-label-no-uppercase">Total Pembayaran</span>
          <input
            type="text"
            class="input-style disable-input"
            placeholder="Rp0"
            v-model="totalPembayaran"
            readonly
            disabled
          />
        </div>
      </div>

      <div class="flex-column">
        <span class="text-note">*Belum termasuk potongan pajak 20%</span>
        <span class="text-note">**Hasil perhitungan ini bersifat estimasi</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardEstimasiPerhitungan",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      penempatanDana: '',
      estimasiBagiHasil: '',
      totalPengembalian: '',
      totalPembayaran: ''
    };
  },
  computed: {
    jangkaWaktu() {
      if (!this.data) return '-';
      const subCat = this.data.sub_category || this.data.subCategory || this.data.sub_product_category;
      const name = subCat && (subCat.name || subCat);
      if (typeof name === 'string') {
        return name.replace(/^Deposito\s*/i, '');
      }
      return '-';
    },
  },
  mounted() {
    // console.log("Data yang diterima di estimasi:", this.data);
  },
  methods: {
    formatRupiahValue(value) {
      if (value == null || value === '') return '';

      let number;

      if (typeof value === 'number') {
        number = value;
      } else {
        const cleaned = value
          .toString()
          .replace(/[^0-9,\.]/g, '')
          .replace(',', '.');

        number = parseFloat(cleaned);
      }

      if (isNaN(number)) return '';

      const rounded = Math.round(number);

      return 'Rp ' + rounded.toLocaleString('id-ID');
    },
    parseRupiahToNumber(val) {
      return Number(String(val || '').replace(/[^\d]/g, ''));
    },
    onPenempatanInput() {
      const nilaiAngka = this.parseRupiahToNumber(this.penempatanDana);

      if (!nilaiAngka) {
        this.penempatanDana = '';
        this.estimasiBagiHasil = '';
        this.totalPengembalian = '';
        this.totalPembayaran = '';
        return;
      }

      this.penempatanDana = this.formatRupiahValue(nilaiAngka);
      
      let tenor = 1;
      const subCat = this.data && (this.data.sub_category || this.data.subCategory || this.data.sub_product_category);
      if (subCat) {
        if (subCat.id === 1) {
          tenor = 1;
        } else if (subCat.id === 2) {
          tenor = 3;
        } else if (subCat.id === 3) {
          tenor = 6;
        } else if (subCat.id === 4) {
          tenor = 12;
        } else if (subCat.name) {
          const match = String(subCat.name).match(/\d+/);
          tenor = match ? parseInt(match[0], 10) : 1;
        }
      }

      const equalRate = parseFloat((this.data && this.data.equal_rate) || 0);

      const BagiHasilcounted = (equalRate / 100) * (tenor / 12) * nilaiAngka;

      const pengembalian = nilaiAngka + BagiHasilcounted;

      const bagiHasil = this.formatRupiahValue(BagiHasilcounted);
      const pengembalianHasil = this.formatRupiahValue(pengembalian);
      const pembayaranHasil = this.formatRupiahValue(nilaiAngka);
      
      this.estimasiBagiHasil = bagiHasil;
      this.totalPengembalian = pengembalianHasil;
      this.totalPembayaran = pembayaranHasil;
    }
  }
};
</script>


<style scoped>
.detail-product-card {
  padding: 25px 30px;
  border: 1px solid #6c6d70;
  display: flex;
  flex-direction: column;
  gap: 30px;
  border-radius: 15px;
  width: 100%;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-label {
  gap: 20px;
}

.gap-label-value {
  gap: 10px;
}

.text-label {
  font-size: 24px;
  text-transform: uppercase;
  color: #13346c;
  font-weight: 500;
}

.text-label-no-uppercase {
  font-size: 20px;
  color: #13346c;
  font-weight: 600;
}

.text-note {
  font-style: italic;
  font-size: 12px;
  color: #6c6d70;
}

.gray-divider {
  border-bottom: 1px solid #6c6d70;
  width: 100%;
}

.input-style {
  font-size: 18px;
  background-color: #ffffff;
  border: 1px solid #6c6d70;
  border-radius: 10px;
  padding: 7px;
}
.disable-input{
  background-color: #eaeaea !important;
}

@media (max-width: 768px) {
  .detail-product-card {
    padding: 25px 30px;
  }
  .disable-input{
  background-color: #eaeaea !important;
}
  .text-label,
  .text-label-no-uppercase {
    font-size: 16px !important;
  }

  .text-note {
    font-size: 12px;
  }

  .input-style {
    font-size: 12px !important;
    padding: 8px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/component-detail-deposito-tabungan/CardEstimasiPerhitungan.vue